var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "widthFull center pt-1 pb-3" },
    [
      _vm.loadingState ? _c("loading") : _vm._e(),
      _vm._v(" "),
      _c("div", { staticClass: "container" }, [
        _c("div", { staticClass: "row justify-content-center pb-3" }, [
          _c("div", { staticClass: "col-md-12" }, [
            _c("div", { staticClass: "row justify-content-center pb-3" }, [
              _c(
                "div",
                {
                  staticClass: "col-6",
                  class: { underlineBox: _vm.cartVisibile }
                },
                [
                  _c(
                    "p",
                    {
                      staticClass: "pointer small  Bold",
                      on: {
                        click: function($event) {
                          return _vm.showCart()
                        }
                      }
                    },
                    [
                      _c("img", {
                        staticClass: "img-fluid widthFull payImage mb-2",
                        attrs: {
                          src: require("../../assets/images/cardPP.png")
                        }
                      })
                    ]
                  )
                ]
              ),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass: "col-6",
                  class: { underlineBox: _vm.ppButtonVisibile }
                },
                [
                  _c(
                    "p",
                    {
                      staticClass: "pointer small Bold",
                      on: {
                        click: function($event) {
                          return _vm.showPaypal()
                        }
                      }
                    },
                    [
                      _c("img", {
                        staticClass: "img-fluid widthFull payImage mb-2 mt-2",
                        attrs: {
                          src: require("../../assets/images/paypal1.png")
                        }
                      })
                    ]
                  )
                ]
              )
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "col-md-12" }, [
              _c("div", { staticClass: "radio " }, [
                _vm.ppButtonVisibile
                  ? _c(
                      "div",
                      {
                        staticClass: "pp-container center",
                        attrs: { id: "pp-container" }
                      },
                      [
                        _c("div", { attrs: { id: "paypal-button-container" } }),
                        _vm._v(" "),
                        _vm._m(0)
                      ]
                    )
                  : _vm._e()
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "radio " }, [
                _vm.cartVisibile
                  ? _c(
                      "div",
                      {
                        staticClass: "form-container",
                        attrs: { id: "form-container" }
                      },
                      [
                        _c("div", {
                          attrs: { id: "payments-sdk__contingency-lightbox" }
                        }),
                        _vm._v(" "),
                        _c(
                          "form",
                          { staticClass: "center", attrs: { id: "my-form" } },
                          [
                            _vm._m(1),
                            _vm._v(" "),
                            _c("div", { staticClass: "cardinfo-card-number" }, [
                              _c(
                                "label",
                                {
                                  staticClass: "cardinfo-label text-left Bold",
                                  attrs: { for: "card-number" }
                                },
                                [_vm._v("Numero Carta")]
                              ),
                              _vm._v(" "),
                              _c("div", {
                                staticClass: "input-wrapper ",
                                attrs: { id: "card-number" }
                              }),
                              _vm._v(" "),
                              _c("div", {
                                class: _vm.cardClass,
                                attrs: { id: "card-image" }
                              })
                            ]),
                            _vm._v(" "),
                            _vm._m(2),
                            _vm._v(" "),
                            _c("input", {
                              directives: [
                                {
                                  name: "show",
                                  rawName: "v-show",
                                  value: _vm.showCardPayButton,
                                  expression: "showCardPayButton"
                                }
                              ],
                              staticClass: "show-button",
                              attrs: {
                                id: "button-pay",
                                type: "button",
                                value: "Paga"
                              }
                            })
                          ]
                        )
                      ]
                    )
                  : _vm._e()
              ])
            ])
          ])
        ])
      ])
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("p", { staticClass: "small2 mt-4" }, [
      _c("b", [_vm._v("SOFORT")]),
      _vm._v(" un sistema di pagamento Europeo per eseguire "),
      _c("b", [_vm._v("Bonifici Diretti")]),
      _vm._v(
        "\n                utilizzando le proprie credenziali bancarie online per trasferire denaro dal proprio conto bancario nella massima sicurezza.\n              "
      )
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "card-holder-name" }, [
      _c(
        "label",
        {
          staticClass: "cardinfo-label text-left Bold",
          attrs: { for: "card-holder-label" }
        },
        [_vm._v("Titolare Carta")]
      ),
      _vm._v(" "),
      _c("input", {
        staticClass: "input-wrapper widthFull p-4",
        attrs: {
          type: "text",
          id: "card-holder-name",
          name: "card-holder-name",
          autocomplete: "off",
          placeholder: ""
        }
      })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "cardinfo-wrapper" }, [
      _c("div", { staticClass: "cardinfo-exp-date" }, [
        _c(
          "label",
          {
            staticClass: "cardinfo-label text-left Bold",
            attrs: { for: "expiration-date" }
          },
          [_vm._v("Scadenza")]
        ),
        _vm._v(" "),
        _c("div", {
          staticClass: "input-wrapper ",
          attrs: { id: "expiration-date" }
        })
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "cardinfo-cvv" }, [
        _c(
          "label",
          {
            staticClass: "cardinfo-label text-left Bold",
            attrs: { for: "cvv" }
          },
          [_vm._v("CVV")]
        ),
        _vm._v(" "),
        _c("div", { staticClass: "input-wrapper ", attrs: { id: "cvv" } })
      ])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-31b2d0d5", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-31b2d0d5","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/loadDocuments/paypal_nt.vue
// module id = null
// module chunks = 